module.exports = __webpack_public_path__ + "img/adulto33.c3cd0913.jpg";